module.exports = __webpack_public_path__ + "static/lsnifa-logo-inverse-7875199cac2e99144ba3933a2065d4b7.svg";